//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';
import { NavTab } from 'unison';

import { ITrackableComponent, withTracking } from '@utils/withTracking';

interface Props extends Partial<ITrackableComponent> {
  text: string;
  headerIcon?: React.ReactElement;
  headerAction?: React.ReactElement;
  isExpandable?: boolean;
  linkAction?: React.ReactNode;
}

export const SidebarHeaderItem = ({
  headerAction,
  headerIcon,
  isExpandable = false,
  linkAction,
  text,
  trackingId,
}: Props) => {
  return (
    <NavTab className='cu-nav-header-item'>
      <>
        {headerIcon && <div className='cu-nav-header-icon'>{headerIcon}</div>}
        <TrackableHeader
          className={isExpandable ? '' : 'cu-nav-header'}
          trackingId={trackingId}
        >
          {text}
        </TrackableHeader>
        {headerAction && (
          <div className='cu-nav-header-action'>{headerAction}</div>
        )}
        {isExpandable && linkAction && (
          <StyledLinkAction>{linkAction}</StyledLinkAction>
        )}
      </>
    </NavTab>
  );
};

const TrackableHeader = withTracking(
  styled.div(
    ({ theme }) => `
      font-size: ${theme.fontSizes[4]};
      font-weight: ${theme.fontWeights.semiBold};
      margin: ${theme.spacings[4]} 0 ${theme.spacings[2]} 0;
    `,
  ),
);

const StyledLinkAction = styled.div`
  align-self: end;
  margin-left: auto;
`;

export default SidebarHeaderItem;
